import React from 'react';
import { Grid, Typography } from '@mui/material';
import DiscoverCard from './DiscoverCard';
import { useTranslation } from 'react-i18next';
import CustomButton from '../common/CustomButton';
import Title from '../common/Title';
import HorizontalCarousel from '../common/Carousels/HorizontalCarousel/HorizontalCarousel';
import { Brand } from '../Rank/Rank.type';

const Discover = ({
  openContact,
  brands,
  methodologyRef,
}: {
  openContact: () => void;
  brands: Brand[];
  methodologyRef: React.RefObject<HTMLDivElement>;
}) => {
  const [brandSelected, setBrandSelected] = React.useState<Brand | null>(null);

  const { t } = useTranslation();

  const changeBrand = (brand: Brand) => {
    setBrandSelected(brand);
  };

  return (
    <Grid
      item
      xs={12}
      sx={{
        padding: '2rem',
        maxWidth: '1250px !important',
        margin: 'auto',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      ref={methodologyRef}
      id="methodology"
    >
      <DiscoverCard
        changeBrand={changeBrand}
        brands={brands}
        brandSelected={brandSelected}
        openContact={openContact}
      />
      <Grid container item xs={12} sx={{ marginTop: '5rem' }}>
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            paddingBottom: {
              xs: '1rem',
              md: '2rem',
            },
          }}
        >
          <Title title="discover.title2" dark align="left" />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            paddingRight: {
              xs: '0',
              md: '2rem',
            },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: 'black',
              fontWeight: 700,
              textAlign: 'left',
              lineHeight: '155%',
              margin: '.75rem 0 1rem',
              fontSize: '1.1rem',
              fontFamily: 'Arial',

              '& sup': {
                fontSize: '.6em',
                lineHeight: '.5',
              },
            }}
          >
            {t('discover.subtitle2')}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: 'black',
              fontWeight: 400,
              textAlign: 'left',
              lineHeight: '155%',
              margin: '.75rem 0 2rem',
              fontSize: '1rem',
              fontFamily: 'Arial',

              '& sup': {
                fontSize: '.6em',
                lineHeight: '.5',
              },
            }}
          >
            {t('discover.description2')}
          </Typography>
        </Grid>
        <Grid
          item
          container
          xs={12}
          md={6}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            paddingLeft: {
              xs: '0',
              md: '2rem',
            },
          }}
        >
          <Grid item xs={12}>
            <Typography
              variant="body1"
              sx={{
                color: 'black',
                fontWeight: 700,
                textAlign: 'left',
                lineHeight: '155%',
                margin: '.75rem 0 1rem',
                fontSize: '1.1rem',
                fontFamily: 'Arial',

                '& sup': {
                  fontSize: '.6em',
                  lineHeight: '.5',
                },
              }}
            >
              {t('discover.subtitle')}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: 'black',
                fontWeight: 400,
                textAlign: 'left',
                lineHeight: '155%',
                margin: '.75rem 0 2rem',
                fontSize: '1rem',
                fontFamily: 'Arial',

                '& sup': {
                  fontSize: '.6em',
                  lineHeight: '.5',
                },
              }}
            >
              {t('discover.description3')}
            </Typography>
            <CustomButton
              title={t('discover.button')}
              dark
              small
              onClick={openContact}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container item xs={12} sx={{ marginTop: '5rem' }}>
        <HorizontalCarousel
          items={[
            {
              title: t('discover.carousel.1.title'),
              description: t('discover.carousel.1.description'),
            },
            {
              title: t('discover.carousel.2.title'),
              description: t('discover.carousel.2.description'),
            },
            {
              title: t('discover.carousel.3.title'),
              description: t('discover.carousel.3.description'),
            },
            {
              title: t('discover.carousel.4.title'),
              description: t('discover.carousel.4.description'),
            },
            {
              title: t('discover.carousel.5.title'),
              description: t('discover.carousel.5.description'),
            },
          ]}
        />
      </Grid>
    </Grid>
  );
};

export default Discover;

